import { Row } from "antd";
import { YhBox } from "@/components/YhBox";
import { useGlobalModel } from "@/model/globalModel";
import { SearchItem } from "@/components/YhPageHeader/item";
import { accountDataModel } from "./accountDataModel";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";

export const AccountSearchBox = () => {

    const { accountTypeDs } = useGlobalModel()
    const {
        searchParam,
        onSearch,
        onReset,
        updateSearchParam,
        loadData
    } = accountDataModel(model => [model.searchParam]);

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "合约单号",
            fieldName: "code",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 4,
            span: 4,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    ...data,
                    startTime: data.time[0] !== '' ? data.time[0] + ' 00:00:00' : undefined,
                    endTime: data.time[1] !== '' ? data.time[1] + ' 23:59:59' : undefined,
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset,
        }
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
